import { ICompany, CompanyState } from "@/types/company";
import { Company } from "@/models/company";
import { Pagination } from "@/models/pagination";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<CompanyState, ICompany> = {
  single: (state, single) => {
    state.single = new Company(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Company(item));
    state.pagination = pagination;
  },
  clear: (state) => {
    state.single = new Company();
    state.pagination = new Pagination();
  },
};

export default mutations;
